import {Injectable} from '@angular/core';
import {Country} from '@models';

@Injectable({
	            providedIn: 'root'
            })
export class SignupDataService {
	private readonly countriesUrl = 'assets/data/signup-countries.json';
	private readonly geoCountriesUrl = 'assets/data/countries+states.json';
	private readonly practicesUrl = 'assets/data/signup-practices.json';
	private countriesRequest?: Promise<Country[]>;
	private geoCountriesRequest?: Promise<Country[]>;
	private practicesRequest?: Promise<PracticeOption[]>;
	countries: Country[] = [];
	geoCountries: Country[] = [];

	async getCountries(): Promise<Country[]> {
		if (!this.countriesRequest) {
			this.countriesRequest = fetch(this.countriesUrl)
				.then((response) => response.json() as Promise<Country[]>)
				.then((countries) => {
					this.countries = countries;
					return countries;
				});
		}
		return this.countriesRequest;
	}

	async getGeoCountries(): Promise<Country[]> {
		if (!this.geoCountriesRequest) {
			this.geoCountriesRequest = fetch(this.geoCountriesUrl)
				.then((response) => response.json() as Promise<Array<{name: string; states: Array<{name: string}>}>>)
				.then((countries) => {
					const mapped = countries.map((country) => ({
						Name: country.name,
						States: Array.isArray(country.states)
							? country.states.map((state) => ({Name: state.name}))
							: []
					})) as Country[];
					this.geoCountries = mapped;
					return mapped;
				});
		}
		return this.geoCountriesRequest;
	}

	async getPratiques(): Promise<PracticeOption[]> {
		if (!this.practicesRequest) {
			this.practicesRequest = fetch(this.practicesUrl)
				.then((response) => response.json() as Promise<PracticeOption[]>);
		}
		return this.practicesRequest;
	}
}

export type PracticeOption = {
	name: string;
	isChecked: boolean;
};
